import * as UI from "./gameUI.js";
import { frontApp, backgroundApp } from "./appPixi.js";
import { loadingStopped } from "./gameManager.js";
import { settings, getThemeTwoLayout } from "./settings.js";
import * as PIXI from "pixi.js";
import gsap from "gsap";
import PixiPlugin from "gsap/PixiPlugin";
import { startGameProgressBar } from "./CommonProgressBar.js";
import { getRandomValue } from "./utility.js";
import { getActiveThemeSlug } from '../../theme/themes'

const isThemeTwo = () => {
  return getActiveThemeSlug() === 'theme-two' || (typeof document !== 'undefined' && document.body?.classList?.contains('theme-two'));
};

function isLoadingUiReady() {
  return typeof UI.gameAssets?.countdownText === 'object'
    && typeof UI.gameAssets?.loadingText === 'object';
}

// registering the plugin
gsap.registerPlugin(PixiPlugin);

// giving the plugin a reference to the PIXI object
PixiPlugin.registerPIXI(PIXI);

const axisSpeed = 0;
let loadingSpeed = 0.5;
let flewAwaySpeed = 5;
let isExploading = false;
let tl = gsap.timeline();

let boolStart = false;
let boolBlast = false;
let boolStartAxis = false;
let boolIsLoading = false;

let floatCounter = 0;
let startFloating = false;

let graphX;
let graphY;

const cloudTargetPosition = {
  x: 0,
  y: 0,
};

let timer = 0;

const gameValues = {
  xLineTop: null,
  yLineTop: null,
  xCurveFactor: null,
  yCurveFactor: null,
  xIncrement: 0,
};

let duration = 0;
let endTime = 0;
let loadingSessionActive = false;

function showLoadingScreen() {
  UI.containers.loadingContainer.visible = true;
  UI.gameAssets.centerBigText.visible = true;
}

function removeLoadingScreen() {
  UI.containers.loadingContainer.visible = false;
}


function startLoading(remainingSeconds, reset = false) {
  if (!isLoadingUiReady()) return;

  const now = performance.now();
  const remaining = Math.max(0, Number(remainingSeconds) || 0);

  if (remaining <= 0) {
    boolIsLoading = false;
    loadingSessionActive = false;
    removeLoadingScreen();
    return;
  }

  UI.containers.loadingContainer.visible = true;
  boolIsLoading = true;

  if (reset || !loadingSessionActive) {
    loadingSessionActive = true;
    duration = remaining;
    endTime = now + duration * 1000;
    UI.updateCrashLoadingTheme();
  } else {
    // Server timer updates may only shorten the active countdown.
    endTime = Math.min(endTime, now + remaining * 1000);
  }
}

// function startLoading(t) {
//   // console.log("timer", t);

//   UI.containers.loadingContainer.visible = true;
//   boolIsLoading = true;
//   // console.log("t1="+t)
//   timer = t * 60;
//   // console.log("t2="+timer)
//   loadingSpeed = UI.gameAssets.loadingBar1.width / timer;
// }

function clearRocketBlastResidue () {
  if (UI.gameAssets?.rocket) gsap.killTweensOf(UI.gameAssets.rocket);
  if (UI.containers?.rocketContainer) {
    gsap.killTweensOf(UI.containers.rocketContainer);
  }

  boolBlast = false;
  isExploading = false;
  finalCrashedMultiplier = null;

  if (UI.gameAssets?.explosionAnim) {
    UI.gameAssets.explosionAnim.visible = false;
    if (typeof UI.gameAssets.explosionAnim.gotoAndStop === 'function') {
      UI.gameAssets.explosionAnim.gotoAndStop(0);
    }
  }

  if (UI.gameAssets?.rocket) {
    UI.gameAssets.rocket.alpha = 1;
    UI.gameAssets.rocket.rotation = 0;
  }

  if (UI.containers?.rocketContainer) {
    const startX = settings.xCorrectedPos * (UI.appWidth / 1920);
    const startY =
      UI.appHeight - settings.yCorrectedPos * (UI.appWidth / 1920);
    UI.containers.rocketContainer.position.set(startX, startY);
    if (typeof UI.applyAnimationVisibility === 'function') {
      UI.applyAnimationVisibility();
    } else {
      UI.containers.rocketContainer.visible = true;
    }
  }
}

function pauseFlightWithoutBlast () {
  boolStart = false;
  boolStartAxis = false;
}

function startGame() {
  clearRocketBlastResidue();
  boolStartAxis = true;
  boolStart = true;
  boolIsLoading = false;
  loadingSessionActive = false;
  UI.gameAssets.loadingBar2.width = 0;
  removeLoadingScreen();

  UI.gameAssets.centerBigText.visible = true;
  UI.gameAssets.multiplierCrashed = false;
  if (window.matchMedia("(orientation: portrait)").matches) {
    UI.gameAssets.rocket.x = UI.gameAssets.rocket.x + 0;
  } else {
    UI.gameAssets.rocket.x = UI.gameAssets.rocket.x + 0;
  }
  UI.gameAssets.rocket.visible = true;
  UI.gameAssets.rocket.alpha = 1;
  UI.containers.axisContainer.visible = true;
  if (typeof UI.applyAnimationVisibility === 'function') {
    UI.applyAnimationVisibility();
  }

  const isThemeTwoVar = isThemeTwo();
  if (!isThemeTwoVar) {
    UI.ensureClassicRocketLayerOrder();
  } else {
    UI.gameAssets.centerBigText.style.fill = "#85E085";
  }
  UI.updateMultiplierBgBox();
}

let finalCrashedMultiplier = null;

function stopGame() {
  boolBlast = true;
  finalCrashedMultiplier = null;
  UI.gameAssets.cashedoutText1.visible = false;
  UI.gameAssets.cashedoutText2.visible = false;
  UI.gameAssets.cashedoutText3.visible = false;

  if (isThemeTwo()) {
    UI.gameAssets.centerBigText.style.fill = "#F08B74";
  } else {
    UI.gameAssets.multiplierCrashed = true;
  }
  UI.updateMultiplierBgBox();

  //if (window.matchMedia("(orientation: portrait)").matches)
  //  UI.gameAssets.centerBigText.position.set(UI.appWidth * 0.5, UI.appHeight * 0.2)

  // UI.gameAssets.crashCenterText.visible = true
}

function changeRocket(n) {
  // ------ Assets got replaced! ------
  // UI.gameAssets.rocket.texture = UI.gameAssets.rocketTextures[n]
}

function setCenterText (s, { authoritative = false } = {}) {
  if (!UI.gameAssets.centerBigText.visible)
    UI.gameAssets.centerBigText.visible = true;

  const isThemeTwoVar = isThemeTwo();
  // Ensure multiplier text is truncated to max 2 decimal places
  let displayText = s;
  if (typeof s === 'string' && /[xX×]$/.test(s)) {
    const numberPart = parseFloat(s.slice(0, -1));
    if (!isNaN(numberPart)) {
      displayText = numberPart.toFixed(2) + 'x';
    }
  }

  if (boolBlast) {
    if (authoritative || !finalCrashedMultiplier) {
      finalCrashedMultiplier = displayText;
    } else {
      displayText = finalCrashedMultiplier;
    }
  }

  UI.gameAssets.centerBigText.text = displayText;
  if (isThemeTwoVar) {
    UI.gameAssets.centerBigText.style.fill = boolBlast ? "#F08B74" : "#85E085";
  }
  UI.updateMultiplierBgBox();
}

function setValuesToInitial ({
  preserveMultiplierText = false,
  skipLoadingScreen = false,
} = {}) {
  if (!isLoadingUiReady()) return;

  clearRocketBlastResidue();
  window.crashVictoryState = null;
  UI.updateLoadingBarProgress(0);
  UI.gameAssets.countdownText.text = "5";

  const isThemeTwoVar = isThemeTwo()
  if (isThemeTwoVar) {
    UI.gameAssets.loadingText.text = 'Starting in 5';
  } else {
    UI.gameAssets.loadingText.text = "Starting in";
  }
  if (skipLoadingScreen) {
    removeLoadingScreen();
  } else {
    showLoadingScreen();
  }

  if (!preserveMultiplierText) {
    UI.gameAssets.centerBigText.text = "1.00x";
    UI.gameAssets.centerBigText.style.fill = "#FFFFFF";
  }
  UI.gameAssets.multiplierCrashed = false;
  UI.updateMultiplierBgBox();
  // Ensure white color is applied after updateMultiplierBgBox for Theme-One
  if (!preserveMultiplierText && !isThemeTwoVar) {
    UI.gameAssets.centerBigText.style.fill = "#FFFFFF";
    UI.gameAssets.centerBigText.dirty = true;
  }

  UI.gameAssets.crashCenterText.visible = false;

  UI.gameAssets.rocket.visible = false;

  UI.gameAssets.topLineGraph.clear();
  UI.gameAssets.bottomLineGraph.clear();

  gameValues.xLineTop = 0;
  gameValues.yLineTop = 0;
  gameValues.xCurveFactor = 0;
  gameValues.yCurveFactor = 0;
  gameValues.xIncrement = 0;

  boolStartAxis = false;
  boolStart = false;
  boolBlast = false;
  boolIsLoading = false;
  loadingSessionActive = false;
  floatCounter = 0;
  startFloating = false;

  UI.containers.axisContainer.visible = false;

  UI.containers.BgContainer.position.set(0, 0);

  removeLosingTextSetup();
  UI.gameAssets.rocket.alpha = 1;
  UI.gameAssets.rocket.rotation = 0;

  UI.gameAssets.nearestPlane.position.set(
    0 - UI.gameAssets.nearestPlane.width,
    0 - UI.gameAssets.nearestPlane.height,
  );

  UI.gameAssets.farthestPlane.position.set(
    0 - UI.gameAssets.farthestPlane.width,
    0 - UI.gameAssets.farthestPlane.height,
  );

  tl.clear(true);

  // backgroundTargetPosition.x = -UI.gameAssets.background.width *0.5
  // backgroundTargetPosition.y = UI.gameAssets.background.height * 0.7
  UI.containers.cloudContainer.position.set(
    0,
    -backgroundApp.screen.height * 2.5,
  );

  UI.gameAssets.cashedoutText1.visible = false;
  UI.gameAssets.cashedoutText2.visible = false;
  UI.gameAssets.cashedoutText3.visible = false;

  const layout = getThemeTwoLayout(UI.appWidth, UI.appHeight);
  if (isThemeTwoVar) {
    // Keep text + multiplier box in sync (same Y as updateMultiplierBgBox)
    UI.updateMultiplierBgBox();
    if (layout.isPortrait) {
      UI.gameAssets.centerSmallText.position.set(
        UI.gameAssets.centerBigText.x,
        UI.gameAssets.centerBigText.position.y - 10,
      );
    } else {
      UI.gameAssets.centerSmallText.position.set(
        UI.gameAssets.centerBigText.x - UI.gameAssets.centerBigText.width,
        UI.gameAssets.centerBigText.position.y,
      );
    }
  }

  if (!isThemeTwoVar) {
    UI.gameAssets.centerBigText.style.stroke = "#FFFFFF";
    UI.gameAssets.centerBigText.style.strokeThickness = 0;
  } else {
    UI.gameAssets.centerBigText.style.strokeThickness = 0;
  }
  UI.containers.loadingContainer.visible = false;
}

function setCashoutText(num1, num2) {
  UI.gameAssets.cashedoutText1.visible = true;
  UI.gameAssets.cashedoutText2.visible = true;
  UI.gameAssets.cashedoutText3.visible = true;

  UI.gameAssets.cashedoutText2.text = num1;
  UI.gameAssets.cashedoutText3.text = "MULTIPLIER X" + num2;
}

function rocketGapCalculate() {
  if (window.matchMedia("(orientation: portrait)").matches) {
    return settings.axisGap * 1.4;
  }
  return settings.axisGap * 2;
}

function getClassicPathReserve() {
  if (isThemeTwo()) {
    return { maxWidthReduction: 0, maxHeightReduction: 0 };
  }

  const isPortrait = window.innerWidth < window.innerHeight;
  const cardScale = isPortrait ? 0.5 : 1;
  const widthScale = UI.appWidth / 1920;
  const heightScale = UI.appHeight / 1080;
  const padding = 12;

  const boxHeight = 108 * cardScale;
  const top = 20;

  const rocket = UI.gameAssets?.rocket;
  const rocketHalfH = rocket?.height && rocket?.scale?.y
    ? rocket.height * rocket.scale.y * 0.5
    : UI.appHeight * (isPortrait ? 0.12 : 0.075);

  if (isPortrait) {
    return {
      maxWidthReduction: 0,
      maxHeightReduction: (top + boxHeight + padding) * heightScale + rocketHalfH * 0.5,
    };
  }

  return {
    maxWidthReduction: padding * widthScale,
    maxHeightReduction: (top + boxHeight + padding) * heightScale + rocketHalfH * 0.5,
  };
}

function xPosition(x) {
  let maxWidth =
    UI.appWidth -
    rocketGapCalculate() -
    settings.xCorrectedPos * (UI.appWidth / 1920);

  if (!isThemeTwo()) {
    maxWidth -= getClassicPathReserve().maxWidthReduction;
  }
  else {
    // Compact mode: travel further before stopping to bob
    const isMobile = window.matchMedia("(orientation: portrait)").matches;
    const is360View = window.innerWidth <= 360;
    const is540View = window.innerWidth <= 540 && window.innerWidth > 360;
    const is1024View = window.innerWidth <= 1024;
    const is1440View = window.innerWidth <= 1440 && window.innerWidth > 1024;
    const mobileExtra = is360View ? 75 : (is540View ? 80 : 50);
    maxWidth += isMobile ? mobileExtra : (is1024View ? 250 : (is1440View ? 280 : 380));
  }

  const xVal = x * (maxWidth / settings.totalDivisions);

  if (xVal >= maxWidth) {
    startFloating = true;
  }

  return xVal < maxWidth ? xVal : maxWidth;
}

function yValue(y) {
  // return Math.pow(2, y * 0.09)
  return y;
}

function yPosition(y) {
  const isThemeTwoVar = isThemeTwo();
  const isPortrait = window.innerWidth < window.innerHeight;
  let maxHeight =
    UI.appHeight -
    rocketGapCalculate() -
    settings.yCorrectedPos * (UI.appHeight / 1080);

  if (isThemeTwoVar) {
    const layout = getThemeTwoLayout(UI.appWidth, UI.appHeight);
    const is768View = window.innerWidth <= 768;
    const heightScale = is768View ? 1.05 : layout.graphHeightScale;
    maxHeight = maxHeight * heightScale;
  } else {
    maxHeight -= getClassicPathReserve().maxHeightReduction;
  }

  const yVal = y * (maxHeight / settings.totalDivisions);
  const startOffset = isThemeTwoVar ? -60 : -50;

  return yVal < maxHeight ? yVal + startOffset : maxHeight + startOffset;
}

function yLineTopCorrected(y) {
  return UI.appHeight - y;
}

const FLIGHT_TICKER_FPS = 60;

function xIncrementFromElapsed (elapsedSeconds) {
  const elapsed = Math.max(0, Number(elapsedSeconds) || 0);
  return elapsed * 0.1 * (settings.graphSpeed / 100) * FLIGHT_TICKER_FPS;
}

function placeRocketAtProgress () {
  if (startFloating) {
    UI.containers.rocketContainer.position.set(
      gameValues.xLineTop + settings.xCorrectedPos * (UI.appWidth / 1920) + Math.sin(floatCounter * 1.5) * 8 * (UI.appWidth / 1920),
      gameValues.yLineTop - settings.yCorrectedPos * (UI.appWidth / 1920) - Math.cos(floatCounter) * 18 * (UI.appHeight / 1080),
    );
  } else {
    UI.containers.rocketContainer.position.set(
      gameValues.xLineTop + settings.xCorrectedPos * (UI.appWidth / 1920),
      gameValues.yLineTop - settings.yCorrectedPos * (UI.appWidth / 1920),
    );
  }
}

function drawGraphAtCurrentRocket () {
  if (!UI.gameAssets?.topLineGraph || !UI.containers?.rocketContainer) return;

  const isThemeTwoVar = isThemeTwo();
  const lineColor = 0xFFEA00;
  const lineAlpha = 1.0;
  const fillColor = 0xFFFFFF;
  const fillAlpha = isThemeTwoVar ? 0.25 : (0x4D / 0xFF);
  const layout = getThemeTwoLayout(UI.appWidth, UI.appHeight);

  UI.gameAssets.topLineGraph.clear();
  UI.gameAssets.topLineGraph.lineStyle(
    isThemeTwoVar ? layout.graphLineThickness : 6,
    lineColor,
    lineAlpha,
  );

  graphX =
    UI.containers.rocketContainer.x -
    UI.gameAssets.rocket.width * (isThemeTwoVar ? 0.3 : 0.05);
  graphY =
    UI.containers.rocketContainer.y +
    UI.gameAssets.rocket.height * (isThemeTwoVar ? 0.4 : 0.22);

  const localGraphX = graphX - UI.containers.graphContainer.x;
  const localGraphY = graphY - UI.containers.graphContainer.y;

  gameValues.xCurveFactor = localGraphX / (10 / 6);
  gameValues.yCurveFactor = UI.appHeight;

  UI.gameAssets.topLineGraph.moveTo(0, UI.appHeight);
  UI.gameAssets.topLineGraph.quadraticCurveTo(
    gameValues.xCurveFactor,
    gameValues.yCurveFactor,
    localGraphX,
    localGraphY,
  );

  UI.gameAssets.bottomLineGraph.clear();
  UI.gameAssets.bottomLineGraph.beginFill(fillColor, fillAlpha);
  UI.gameAssets.bottomLineGraph.moveTo(0, UI.appHeight);
  UI.gameAssets.bottomLineGraph.quadraticCurveTo(
    gameValues.xCurveFactor,
    gameValues.yCurveFactor,
    localGraphX,
    localGraphY,
  );
  UI.gameAssets.bottomLineGraph.lineTo(localGraphX, UI.appHeight);
  UI.gameAssets.bottomLineGraph.closePath();
  UI.gameAssets.bottomLineGraph.endFill();

  if (!isThemeTwoVar) {
    UI.gameAssets.bottomLineGraph.lineStyle(1, 0xEC9879, 1);
    UI.gameAssets.bottomLineGraph.moveTo(localGraphX, localGraphY);
    UI.gameAssets.bottomLineGraph.lineTo(localGraphX, UI.appHeight);
  }
}

function seekFlightToElapsed (elapsedSeconds) {
  startFloating = false;
  gameValues.xIncrement = xIncrementFromElapsed(elapsedSeconds);
  gameValues.xLineTop = xPosition(gameValues.xIncrement);
  gameValues.yLineTop = yLineTopCorrected(
    yPosition(yValue(gameValues.xIncrement)),
  );
  placeRocketAtProgress();
  drawGraphAtCurrentRocket();
  return gameValues.xIncrement;
}

function resumeFlightFromElapsed (elapsedSeconds, { sameRound = false } = {}) {
  if (!sameRound || boolBlast || isExploading) {
    setValuesToInitial({
      preserveMultiplierText: true,
      skipLoadingScreen: true,
    });
    startGame();
  } else {
    boolBlast = false;
    isExploading = false;
    boolStartAxis = true;
    boolStart = true;
    boolIsLoading = false;
    loadingSessionActive = false;
    removeLoadingScreen();
    if (UI.gameAssets?.rocket) {
      UI.gameAssets.rocket.visible = true;
      UI.gameAssets.rocket.alpha = 1;
    }
    if (UI.containers?.axisContainer) {
      UI.containers.axisContainer.visible = true;
    }
    if (typeof UI.applyAnimationVisibility === 'function') {
      UI.applyAnimationVisibility();
    }
    UI.gameAssets.multiplierCrashed = false;
    UI.updateMultiplierBgBox();
  }

  return seekFlightToElapsed(elapsedSeconds);
}

export function distance(currentPos, targetPos) {
  let distance =
    Math.pow(targetPos.x - currentPos.x, 2) +
    Math.pow(targetPos.y - currentPos.y, 2);
  distance = Math.sqrt(distance);
  return distance;
}

export function moveTowards(currentPos, targetPos, speed) {
  let xDirection = targetPos.x - currentPos.x;
  let yDirection = targetPos.y - currentPos.y;
  currentPos.x += xDirection * speed;
  currentPos.y += yDirection * speed;
  return currentPos;
}

function losingTextSetup() {
  const isThemeTwoVar = isThemeTwo();

  if (isThemeTwoVar) {
    const fillCol = "#F08B74";
    const strokeCol = "#F08B74";
    const strokeTh = 0;

    if (!window.matchMedia("(orientation: portrait)").matches) {
      UI.gameAssets.centerSmallText.x =
        UI.gameAssets.centerBigText.x -
        (UI.gameAssets.centerBigText.width / 2) * 1.25 -
        UI.gameAssets.centerSmallText.width / 2;
      UI.gameAssets.centerBigText.style.fill = fillCol;
    } else {
      UI.gameAssets.centerBigText.style.fill = fillCol;
    }

    UI.gameAssets.centerBigText.style.stroke = strokeCol;
    UI.gameAssets.centerBigText.style.strokeThickness = strokeTh;
    UI.updateMultiplierBgBox();
    return;
  }

  UI.gameAssets.multiplierCrashed = true;
  UI.updateMultiplierBgBox();
}

function removeLosingTextSetup() {
  UI.gameAssets.centerSmallText.visible = false;
  const isThemeTwoVar = isThemeTwo();
  if (isThemeTwoVar) {
    UI.gameAssets.centerBigText.style.fill = "#FFFFFF";
    window.crashVictoryState = null;
  }
}

async function showNearestPlane() {
  UI.gameAssets.nearestPlane.position.set(
    0 - UI.gameAssets.nearestPlane.width,
    0 - UI.gameAssets.nearestPlane.height,
  );

  UI.gameAssets.nearestPlane.isFlying = true;
  UI.gameAssets.nearestPlane.isCrashed = false;
  UI.gameAssets.nearestPlane.alpha = 0.5;
  UI.gameAssets.nearestPlane.rotation = Math.PI / 4;

  await gsap.to(UI.gameAssets.nearestPlane, {
    alpha: 1,
    x: frontApp.stage.width * 0.25,
    y: frontApp.stage.height * 0.35,
    rotation: 0,
    duration: 2,
  });

  while (!UI.gameAssets.nearestPlane.isCrashed) {
    await gsap.to(UI.gameAssets.nearestPlane, {
      y: frontApp.stage.height * 0.3,
      duration: 7,
    });

    await gsap.to(UI.gameAssets.nearestPlane, {
      y: frontApp.stage.height * 0.4,
      duration: 7,
    });
  }
}

async function showFarthestPlane() {
  UI.gameAssets.farthestPlane.position.set(
    0 - UI.gameAssets.farthestPlane.width,
    0 - UI.gameAssets.farthestPlane.height,
  );

  UI.gameAssets.farthestPlane.isFlying = true;
  UI.gameAssets.farthestPlane.isCrashed = false;
  UI.gameAssets.farthestPlane.alpha = 0.5;
  UI.gameAssets.farthestPlane.rotation = Math.PI / 4;

  await gsap.to(UI.gameAssets.farthestPlane, {
    pixi: {
      alpha: 1,
      x: frontApp.stage.width * 0.3,
      y: frontApp.stage.height * 0.55,
      rotation: 0,
    },
    duration: 2,
  });

  while (!UI.gameAssets.farthestPlane.isCrashed) {
    await gsap.to(UI.gameAssets.farthestPlane, {
      y: frontApp.stage.height * 0.5,
      duration: 7,
    });

    await gsap.to(UI.gameAssets.farthestPlane, {
      y: frontApp.stage.height * 0.6,
      duration: 7,
    });
  }
}

async function crashNearestPlane() {
  UI.gameAssets.nearestPlane.isFlying = false;
  UI.gameAssets.nearestPlane.isCrashed = true;

  await gsap.to(UI.gameAssets.nearestPlane, {
    rotation: Math.PI / 6,
    duration: 0.3,
  });
  await gsap.to(UI.gameAssets.nearestPlane, {
    alpha: 0,
    x: frontApp.stage.width * 0.5,
    y: frontApp.stage.height,
    duration: 1.5,
  });
}

async function crashFarthestPlane() {
  UI.gameAssets.farthestPlane.isFlying = false;
  UI.gameAssets.farthestPlane.isCrashed = true;

  await gsap.to(UI.gameAssets.farthestPlane, {
    rotation: Math.PI / 6,
    duration: 0.3,
  });
  await gsap.to(UI.gameAssets.farthestPlane, {
    alpha: 0,
    x: frontApp.stage.width * 0.5,
    y: frontApp.stage.height,
    duration: 1.5,
  });
}

async function crashMainPlane() {
  await gsap.to(UI.gameAssets.rocket, {
    rotation: Math.PI / 4,
    duration: 0.4,
  });

  await gsap.to(UI.gameAssets.rocket, {
    alpha: 0,
    duration: 0.8,
  });
}

frontApp.ticker.add((delta) => {
  //Loading=======================
  // if (boolIsLoading) {
  //   if (timer > 0) {
  //     timer -= delta * 1.3
  //     // console.log(timer)
  //     UI.gameAssets.countdownText.text = Math.max(0, (timer / 100).toFixed(0))
  //     if (UI.gameAssets.loadingBar2.width < UI.gameAssets.loadingBar1.width * 0.96)
  //       UI.gameAssets.loadingBar2.width += loadingSpeed * 1.3 * delta
  //   } else {
  //     boolIsLoading = false
  //     //removeLoadingScreen()
  //     loadingStopped()
  //   }
  // }

  if (boolIsLoading && isLoadingUiReady()) {
    const now = performance.now();
    const remaining = Math.max(0, (endTime - now) / 1000);

    if (remaining > 0) {
      const countdownValue = Math.ceil(remaining)
      UI.gameAssets.countdownText.text = countdownValue

      const isThemeTwoVar = isThemeTwo()
      if (isThemeTwoVar) {
        UI.gameAssets.loadingText.text = 'Starting in'
      }

      const maxProgress = isThemeTwoVar ? 0.96 : 1;
      const progress = duration > 0
        ? Math.min(1, Math.max(0, 1 - (remaining / duration)))
        : 0;
      UI.updateLoadingBarProgress(maxProgress * progress);
    } else {
      boolIsLoading = false;
      loadingSessionActive = false;
      removeLoadingScreen();
      UI.gameAssets.countdownText.text = 0
      UI.updateLoadingBarProgress(0);
      loadingStopped();
    }
  }



  if (boolBlast) {
    UI.containers.rocketContainer.position.set(
      UI.containers.rocketContainer.position.x + flewAwaySpeed * 0.15 * delta,
      UI.containers.rocketContainer.position.y + flewAwaySpeed * 0.5 * delta,
    );
    if (!isExploading) {
      UI.gameAssets.explosionAnim.visible = true;
      UI.gameAssets.explosionAnim.gotoAndPlay(0);
      losingTextSetup();
      isExploading = true;
      crashMainPlane();
      if (UI.gameAssets.farthestPlane.isFlying) {
        crashFarthestPlane();
      }

      if (UI.gameAssets.nearestPlane.isFlying) {
        crashNearestPlane();
      }
    }
    return;
  }

  if (boolStartAxis) {
    UI.gameAssets.axisDots.x.forEach((element) => {
      element.position.x -= delta * axisSpeed;
      if (element.position.x < UI.appWidth * 0.015)
        element.position.x = UI.appWidth;
    });
    UI.gameAssets.axisDots.y.forEach((element) => {
      element.position.y += delta * axisSpeed;
      if (element.position.y > UI.appHeight * 0.985) element.position.y = 0;
    });
  }

  if (boolStart) {
    gameValues.xIncrement += 0.1 * (settings.graphSpeed / 100) * delta;
    gameValues.xLineTop = xPosition(gameValues.xIncrement);
    gameValues.yLineTop = yLineTopCorrected(
      yPosition(yValue(gameValues.xIncrement)),
    );

    if (startFloating) {
      if (!UI.gameAssets.farthestPlane.isFlying) showFarthestPlane();
      if (!UI.gameAssets.nearestPlane.isFlying) showNearestPlane();
      floatCounter += 0.01 * delta;
      UI.containers.rocketContainer.position.set(
        gameValues.xLineTop + settings.xCorrectedPos * (UI.appWidth / 1920) + Math.sin(floatCounter * 1.5) * 8 * (UI.appWidth / 1920),
        gameValues.yLineTop - settings.yCorrectedPos * (UI.appWidth / 1920) - Math.cos(floatCounter) * 18 * (UI.appHeight / 1080),
      );
    } else {
      UI.containers.rocketContainer.position.set(
        gameValues.xLineTop + settings.xCorrectedPos * (UI.appWidth / 1920),
        gameValues.yLineTop - settings.yCorrectedPos * (UI.appWidth / 1920),
      );
    }

    const isThemeTwoVar = isThemeTwo()
    const lineColor = 0xFFEA00
    const lineAlpha = 1.0
    const fillColor = 0xFFFFFF
    const fillAlpha = isThemeTwoVar ? 0.25 : (0x4D / 0xFF)

    const layout = getThemeTwoLayout(UI.appWidth, UI.appHeight);
    UI.gameAssets.topLineGraph.clear();
    UI.gameAssets.topLineGraph.lineStyle(
      isThemeTwoVar ? layout.graphLineThickness : 6,
      lineColor,
      lineAlpha
    );

    graphX = boolBlast
      ? graphX
      : UI.containers.rocketContainer.x - UI.gameAssets.rocket.width * (isThemeTwoVar ? 0.3 : 0.05); //40
    graphY = boolBlast
      ? graphY
      : UI.containers.rocketContainer.y + UI.gameAssets.rocket.height * (isThemeTwoVar ? 0.4 : 0.22); //60

    const localGraphX = graphX - UI.containers.graphContainer.x;
    const localGraphY = graphY - UI.containers.graphContainer.y;

    gameValues.xCurveFactor = localGraphX / (10 / 6);
    gameValues.yCurveFactor = UI.appHeight;

    UI.gameAssets.topLineGraph.moveTo(0, UI.appHeight);
    UI.gameAssets.topLineGraph.quadraticCurveTo(
      gameValues.xCurveFactor,
      gameValues.yCurveFactor,
      localGraphX,
      localGraphY,
    );

    UI.gameAssets.bottomLineGraph.clear();
    UI.gameAssets.bottomLineGraph.beginFill(fillColor, fillAlpha);

    UI.gameAssets.bottomLineGraph.moveTo(0, UI.appHeight);
    UI.gameAssets.bottomLineGraph.quadraticCurveTo(
      gameValues.xCurveFactor,
      gameValues.yCurveFactor,
      localGraphX,
      localGraphY,
    );

    UI.gameAssets.bottomLineGraph.lineTo(localGraphX, UI.appHeight);
    UI.gameAssets.bottomLineGraph.closePath();
    UI.gameAssets.bottomLineGraph.endFill();

    if (!isThemeTwoVar) {
      UI.gameAssets.bottomLineGraph.lineStyle(1, 0xEC9879, 1);
      UI.gameAssets.bottomLineGraph.moveTo(localGraphX, localGraphY);
      UI.gameAssets.bottomLineGraph.lineTo(localGraphX, UI.appHeight);
    }
  }
});

backgroundApp.ticker.add(() => {
  if (boolBlast) return;
  UI.containers.BgContainer.position.set(0, 0);
});

export function isGameStarted() {
  return boolStart;
}

export function isBlastActive() {
  return boolBlast;
}

export {
  startGame,
  setValuesToInitial,
  stopGame,
  startLoading,
  changeRocket,
  setCenterText,
  setCashoutText,
  pauseFlightWithoutBlast,
  resumeFlightFromElapsed,
};
